import { useEffect } from 'react';
import r from 'render-dom';
import { connect } from 'react-redux';
import { usePlanContext } from 'hooks';

import { login } from 'redux/auth/actions';
import { patch as patchCompany } from 'redux/company/actions';
import { post as postKeyword } from 'redux/keywords/actions';
import { saveListing as createListing } from 'redux/listing/actions';
import { signup } from 'redux/me/actions';
import { fetch as fetchProducts } from 'redux/products/actions';
import { postSubscription, updateCard } from 'redux/subscription/actions';
import { getJwt, setJwt } from 'utils/jwt';

import AccountSetup from './AccountSetup';

function AccountSetupWrapper({ hasFetchedPlans, ...props }) {
    const [, , plans, isFetchingPlans, getPlans] = usePlanContext();
    useEffect(() => {
        if (!hasFetchedPlans && !isFetchingPlans) {
            getPlans();
        }
    }, []);

    if (hasFetchedPlans) {
        return r(AccountSetup, { ...props, plans });
    }

    return null;
}

export default connect(
    ({ plans, products }) => {
        const { search } = window.location;
        if (search && search.length > 0) {
            const params = search.slice(1).split('&')
                .map((x) => x.split('='));

            const token = params.find((x) => x[0] === 'token');
            if (token) {
                setJwt(token[1]);
            }
        }

        return {
            hasFetchedPlans: plans.get('hasFetched'),
            hasProducts: products.get('data').size > 0,
            jwt: getJwt() || '',
        };
    },
    {
        createListing,
        fetchProducts,
        login,
        patchCompany,
        postKeyword,
        postSubscription,
        signup,
        updateCard,
    }
)(AccountSetupWrapper);
